import { render } from "./TForm.vue?vue&type=template&id=11be4b81"
import script from "./TForm.vue?vue&type=script&lang=js"
export * from "./TForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__